import { atom } from "recoil";

export const ContactsPerPageAtom = atom<number | undefined>({
  key: "ContactsPerPage",
  default: 0,
});
